import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";

import { MedIconFolderComponent } from "./med-icon-folder.component";

@NgModule({
  declarations: [
    MedIconFolderComponent,
  ],
  imports: [
    CommonModule,
  ],
  exports: [
    MedIconFolderComponent,
  ],
})
export class MedIconFolderModule { }
